import router, { RouteNames } from '@/router';
import { NavigationFailure } from 'vue-router';

const showErrorView = async (
  message: string,
  description = '',
  showAdminLink = false,
): Promise<void | NavigationFailure | undefined> => {
  return await router.push({
    name: RouteNames.Error,
    params: { message, description, showAdminLink: String(showAdminLink) },
  });
};

export default showErrorView;
